import { getSelectedModelTypes } from "./helpers";
import {
  ResolutionIcon,
  DeviceIcon,
  CameraIcon,
  DeviceType,
  HandednessIcon,
  OrientationIcon,
  ClubTypeIcon,
  SwingTypeIcon,
  GolfPoseActiveIcon,
  AthleticsActiveIcon,
  BaseballActiveIcon,
  FullSwingInActiveIcon,
  FullSwingActiveIcon,
  ShortGameInActiveIcon,
  ShortGameActiveIcon,
  PuttingInActiveIcon,
  PuttingActiveIcon,
  BunkerInActiveIcon,
  BunkerActiveIcon,
  IronInActiveIcon,
  IronActiveIcon,
  DriverInActiveIcon,
  DriverActiveIcon,
  WedgeInActiveIcon,
  WedgeActiveIcon,
  HybridInActiveIcon,
  HybridActiveIcon,
  FaceOnInActiveIcon,
  FaceOnActiveIcon,
  RightHandedInActiveIcon,
  RightHandedActiveIcon,
  LeftHandedInActiveIcon,
  LeftHandedActiveIcon,
  DownTheLineInActiveIcon,
  DownTheLineActiveIcon,
  IosActiveIcon,
  IosInActiveIcon,
  AndroidActiveIcon,
  AndroidInActiveIcon,
  StudioActiveIcon,
  StudioInActiveIcon,
  PortraitInActiveIcon,
  PortraitActiveIcon,
  CameraResolutionIconActive,
  CameraFrontInActiveIcon,
  CameraBackInActiveIcon,
  OtherActiveIcon,
  CameraResolutionIconInActive,
  OtherResolutionIconInActive,
  FrontCameraActiveIcon,
  BackCameraActiveIcon,
  BaseballPoseActiveIcon,
  BaseballPoseInActiveIcon,
  BaseballBatInActiveIcon,
  BaseballBatActiveIcon,
  BaseballInActiveIcon,
  BaseballCombinedActiveIcon,
  GolfPoseInActiveIcon,
  GolfClubInActiveIcon,
  GolfClubActiveIcon,
  GolfBallInActive,
  GolfBallActiveIcon,
  GolfcombinedInActiveIcon,
  GolfCombinedActiveIcon,
  AthleticsInActiveIcon,
  TrueIconInActive,
  TrueIconActive,
  FalseIconInActive,
  FalseIconActive,
  AutoIconInActive,
  AutoIconActive,
  ManualIconInActive,
  ManualIconActive,
  BaseballCombinedInActiveIcon,
  PitcherInActiveIcon,
  PitcherActiveIcon,
  BatterInActiveIcon,
  BatterActiveIcon,
  BaseballFaceOnInInActiveIcon,
  BaseballFaceOnActiveIcon,
  BaseballDTLInActiveIcon,
  BaseballDTLActiveIcon,
  BaseballLeftHandedInActiveIcon,
  BaseballLeftHandedActiveIcon,
  BaseballRightHandedInActiveIcon,
  BaseballRightHandedActiveIcon,
  LandscaapeInActiveIcon,
  LandscaapeActiveIcon,
} from "./icons";

export const stylesForTab = {
  textTransform: "none",
  minHeight: "20px",
  padding: "14px 16px 12px 16px",
};

export const SPORT_KEYS = {
  GOLF: "golf",
  BASEBALL: "baseball",
  ATHLETICS: "athletics",
};

const { ATHLETICS, BASEBALL, GOLF } = SPORT_KEYS;

export const sportTabsData = [
  {
    key: GOLF,
    label: "Golf",
    icon: GolfPoseInActiveIcon,
    activeIcon: GolfPoseActiveIcon,
  },
  {
    key: BASEBALL,
    label: "Baseball",
    icon: BaseballPoseInActiveIcon,
    activeIcon: BaseballPoseActiveIcon,
  },
  {
    key: ATHLETICS,
    label: "Athletics",
    icon: AthleticsInActiveIcon,
    activeIcon: AthleticsActiveIcon,
  },
];

export const modelTypeListForGolf = {
  title: "Model Type",
  key: "modelType",
  options: [
    {
      value: "pose",
      label: "Pose",
      icon: GolfPoseInActiveIcon,
      activeIcon: GolfPoseActiveIcon,
      pose: true,
      version: 1.024,
    },
    {
      value: "club",
      label: "Club",
      icon: GolfClubInActiveIcon,
      activeIcon: GolfClubActiveIcon,
      club: true,
      version: 1.024,
    },
    {
      value: "ball",
      label: "Ball",
      icon: GolfBallInActive,
      activeIcon: GolfBallActiveIcon,
      ball: false,
      version: 1.024,
    },
    {
      value: "combined",
      label: "Combined",
      icon: GolfcombinedInActiveIcon,
      activeIcon: GolfCombinedActiveIcon,
      combined: false,
      version: 1.024,
    },
  ],
};
export const modelTypeListForBaseBall = {
  title: "Model Type",
  key: "modelType",
  options: [
    {
      value: "pose",
      label: "Pose",
      icon: BaseballPoseInActiveIcon,
      activeIcon: BaseballPoseActiveIcon,
      pose: true,
      version: 1.024,
    },
    {
      value: "club",
      label: "Baseball Bat",
      icon: BaseballBatInActiveIcon,
      activeIcon: BaseballBatActiveIcon,
      club: true,
      version: 1.024,
    },
    {
      value: "ball",
      label: "Ball",
      icon: BaseballInActiveIcon,
      activeIcon: BaseballActiveIcon,
      ball: false,
      version: 1.024,
    },
    {
      value: "combined",
      label: "Combined",
      icon: BaseballCombinedInActiveIcon,
      activeIcon: BaseballCombinedActiveIcon,
      combined: false,
      version: 1.024,
    },
  ],
};
export const modelTypeListForAthletics = {
  title: "Model Type",
  key: "modelType",
  options: [
    {
      value: "pose",
      label: "Pose",
      icon: AthleticsInActiveIcon,
      activeIcon: AthleticsActiveIcon,
      pose: true,
      version: 1.024,
    },
  ],
};

export const optionalCameraSettingsOptions = [
  {
    title: "Camera Moved",
    key: "isCameraMoved",
    icon: DeviceIcon,
    options: [
      {
        value: "Yes",
        label: "Yes",
        icon: TrueIconInActive,
        activeIcon: TrueIconActive,
      },
      {
        value: "No",
        label: "No",
        icon: FalseIconInActive,
        activeIcon: FalseIconActive,
      },
    ],
  },
  {
    title: "Device Type",
    key: "deviceType",
    icon: DeviceType,
    options: [
      {
        value: "ios",
        label: "IOS",
        icon: IosInActiveIcon,
        activeIcon: IosActiveIcon,
      },
      {
        value: "android",
        label: "Android",
        icon: AndroidInActiveIcon,
        activeIcon: AndroidActiveIcon,
      },
      {
        value: "studio",
        label: "Studio",
        icon: StudioInActiveIcon,
        activeIcon: StudioActiveIcon,
      },
    ],
  },
];
export const optionalSwingSettingOptions = [
  {
    title: "Trigger Type",
    key: "trigger_type",
    icon: DeviceIcon,
    options: [
      {
        value: "auto",
        label: "Auto",
        icon: AutoIconInActive,
        activeIcon: AutoIconActive,
      },
      {
        value: "manual",
        label: "Manual",
        icon: ManualIconInActive,
        activeIcon: ManualIconActive,
      },
    ],
  },
];

export const initialStateOfModelTypeKeys = {
  pose: true,
  club: true,
  ball: false,
  combined: false,
};

export const frameRateMarks = [
  { label: "1", value: 1 },
  { label: "60", value: 60 },
  { label: "120", value: 120 },
  { label: "180", value: 180 },
  { label: "240", value: 240 },
  { label: "300", value: 300 },
  { label: "360", value: 360 },
  { label: "420", value: 420 },
  { label: "480", value: 480 },
];

export const luxMarks = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
  { label: "11", value: 11 },
  { label: "12", value: 12 },
  { label: "13", value: 13 },
  { label: "14", value: 14 },
];
export const ISOMarks = [
  { label: "50", value: 50 },
  { label: "150", value: 150 },
  { label: "250", value: 250 },
  { label: "350", value: 350 },
  { label: "450", value: 450 },
  { label: "550", value: 550 },
  { label: "650", value: 650 },
  { label: "750", value: 750 },
  { label: "800", value: 800 },
];
export const shutterMarks = [
  { label: "1000", value: 1000 },
  { label: "2000", value: 2000 },
  { label: "3000", value: 3000 },
  { label: "4000", value: 4000 },
  { label: "5000", value: 5000 },
  { label: "6000", value: 6000 },
  { label: "7000", value: 7000 },
  { label: "8000", value: 8000 },
  { label: "9000", value: 9000 },
];

export const swingSettingOptions = [
  {
    title: "Swing Type",
    key: "swingType",
    icon: SwingTypeIcon,
    options: [
      {
        value: "full swing",
        label: "Full Swing",
        icon: FullSwingInActiveIcon,
        activeIcon: FullSwingActiveIcon,
      },
      {
        value: "short game",
        label: "Short Game",
        icon: ShortGameInActiveIcon,
        activeIcon: ShortGameActiveIcon,
      },
      {
        value: "putting",
        label: "Putting",
        icon: PuttingInActiveIcon,
        activeIcon: PuttingActiveIcon,
      },
      {
        value: "bunker",
        label: "Bunker",
        icon: BunkerInActiveIcon,
        activeIcon: BunkerActiveIcon,
      },
    ],
  },
  {
    title: "Club Type",
    key: "clubType",
    icon: ClubTypeIcon,
    options: [
      {
        value: "iron",
        label: "Iron",
        icon: IronInActiveIcon,
        activeIcon: IronActiveIcon,
      },
      {
        value: "driver",
        label: "Driver",
        icon: DriverInActiveIcon,
        activeIcon: DriverActiveIcon,
      },
      {
        value: "wedge",
        label: "Wedge",
        icon: WedgeInActiveIcon,
        activeIcon: WedgeActiveIcon,
      },
      {
        value: "hybrid",
        label: "Hybrid",
        icon: HybridInActiveIcon,
        activeIcon: HybridActiveIcon,
      },
    ],
  },
  {
    title: "Orientation",
    key: "orientation",
    icon: OrientationIcon,
    options: [
      {
        value: "FaceOn",
        label: "Face On",
        icon: FaceOnInActiveIcon,
        activeIcon: FaceOnActiveIcon,
      },
      {
        value: "DownTheLine",
        label: "Down the Line",
        icon: DownTheLineInActiveIcon,
        activeIcon: DownTheLineActiveIcon,
      },
    ],
  },
  {
    title: "Handedness",
    key: "handedness",
    icon: HandednessIcon,
    options: [
      {
        value: "leftHanded",
        label: "Left Handed",
        icon: LeftHandedInActiveIcon,
        activeIcon: LeftHandedActiveIcon,
      },
      {
        value: "rightHanded",
        label: "Right Handed",
        icon: RightHandedInActiveIcon,
        activeIcon: RightHandedActiveIcon,
      },
    ],
  },
];
export const baseBallSettingOptions = [
  {
    title: "Movement Type",
    key: "movement_type",
    icon: OrientationIcon,
    options: [
      {
        value: "pitching",
        label: "Pitcher",
        icon: PitcherInActiveIcon,
        activeIcon: PitcherActiveIcon,
      },
      {
        value: "batter",
        label: "Batter",
        icon: BatterInActiveIcon,
        activeIcon: BatterActiveIcon,
      },
    ],
  },
  {
    title: "Orientation",
    key: "orientation",
    icon: OrientationIcon,
    options: [
      {
        value: "FaceOn",
        label: "Face On",
        icon: BaseballFaceOnInInActiveIcon,
        activeIcon: BaseballFaceOnActiveIcon,
      },
      {
        value: "DownTheLine",
        label: "Down the Line",
        icon: BaseballDTLInActiveIcon,
        activeIcon: BaseballDTLActiveIcon,
      },
    ],
  },
  {
    title: "Handedness",
    key: "handedness",
    icon: HandednessIcon,
    options: [
      {
        value: "leftHanded",
        label: "Left Handed",
        icon: BaseballLeftHandedInActiveIcon,
        activeIcon: BaseballLeftHandedActiveIcon,
      },
      {
        value: "rightHanded",
        label: "Right Handed",
        icon: BaseballRightHandedInActiveIcon,
        activeIcon: BaseballRightHandedActiveIcon,
      },
    ],
  },
];
export const exerciseSettingOptions = [
  {
    title: "Exercise Type",
    key: "exerciseType",
    icon: SwingTypeIcon,
    options: [
      {
        value: "power",
        label: "Power",
        icon: FullSwingInActiveIcon,
        activeIcon: FullSwingActiveIcon,
      },
      {
        value: "mobility",
        label: "Mobility",
        icon: ShortGameInActiveIcon,
        activeIcon: ShortGameActiveIcon,
      },
      {
        value: "strength",
        label: "Strength",
        icon: PuttingInActiveIcon,
        activeIcon: PuttingActiveIcon,
      },
    ],
  },
];

export const cameraSettingsOptions = [
  {
    title: "Camera",
    key: "device_camera",
    icon: CameraIcon,
    options: [
      {
        value: "front",
        label: "Front",
        icon: CameraFrontInActiveIcon,
        activeIcon: FrontCameraActiveIcon,
      },
      {
        value: "back",
        label: "Back",
        icon: CameraBackInActiveIcon,
        activeIcon: BackCameraActiveIcon,
      },
    ],
  },
  {
    title: "Resolution",
    key: "resolution",
    icon: ResolutionIcon,
    options: [
      {
        value: "1920X1080",
        label: "1920X1080",
        icon: CameraResolutionIconInActive,
        activeIcon: CameraResolutionIconActive,
      },
      {
        value: "other",
        label: "Other",
        icon: OtherResolutionIconInActive,
        activeIcon: OtherActiveIcon,
      },
    ],
  },
];

export const cameraSettingsOptionsBaseball = [
  {
    title: "Camera",
    key: "device_camera",
    icon: CameraIcon,
    options: [
      {
        value: "front",
        label: "Front",
        icon: CameraFrontInActiveIcon,
        activeIcon: FrontCameraActiveIcon,
      },
      {
        value: "back",
        label: "Back",
        icon: CameraBackInActiveIcon,
        activeIcon: BackCameraActiveIcon,
      },
    ],
  },
  {
    title: "Device Orientation",
    key: "device_orientation",
    icon: ResolutionIcon,
    options: [
      {
        value: "portrait",
        label: "Portrait",
        icon: PortraitInActiveIcon,
        activeIcon: PortraitActiveIcon,
      },
      {
        value: "landscape",
        label: "Landscape",
        icon: LandscaapeInActiveIcon,
        activeIcon: LandscaapeActiveIcon,
      },
    ],
  },
];

export const cameraTypeDropdownOptions = [
  {
    value: "single",
    label: "Single Camera",
  },
  {
    value: "multi",
    label: "Multi Camera",
  },
];

export const sportNameObj = {
  golf: GOLF,
  baseball: BASEBALL,
  athletics: ATHLETICS,
};

export const golfData = {
  sportName: GOLF,
  cameraType: "single",
  swingType: "full swing",
  clubType: "iron",
  orientation: "FaceOn",
  handedness: "rightHanded",
  exerciseType: "power",
  resolution: "1920X1080",
  isCameraMoved: "No",
  deviceType: "ios",
  device_camera: "front",
  trigger_type: "manual",
  modelType: getSelectedModelTypes(modelTypeListForGolf),
  // capturedFrameRate: capturedFrameRateDefault,
};
export const athleticsData = {
  modelType: getSelectedModelTypes(modelTypeListForAthletics),
  sportName: ATHLETICS,
  exerciseType: "power",
  // capturedFrameRate: capturedFrameRateDefault,

  // cameraType: "single",
  // swingType: "full swing",
  // clubType: "iron",
  // orientation: "FaceOn",
  // handedness: "rightHanded",
  // resolution: "1920X1080",
  // isCameraMoved: "false",
  // deviceType: "ios",
  // device_camera: "front",
  // trigger_type: "manual",
};

export const baseballData = {
  file_name: "",
  sportName: BASEBALL,
  movement_type: "pitching",
  player_role: "coach",
  handedness: "rightHanded",
  device_camera: "back",
  isCameraMoved: "No",
  orientation: "FaceOn",
  deviceType: "ios",
  device_orientation: "landscape",
  trigger_type: "manual",
  iso: 4000,
  shutter: 250,
  lux: 6,
  modelType: getSelectedModelTypes(modelTypeListForBaseBall),
  // email: user?.email,
};

export const swingSettingsData = {
  swingType: "full swing",
  clubType: "iron",
  orientation: "FaceOn",
  handedness: "rightHanded",
  triggerType: "",
};

export const cameraSettingsData = {
  deviceType: "",
  isCameraMoved: "",
  resolution: "1920X1080",
  device_camera: "front",
};
